import { render, staticRenderFns } from "./PrintBearVoucher.vue?vue&type=template&id=01388a1b&scoped=true"
var script = {}
import style0 from "./PrintBearVoucher.vue?vue&type=style&index=0&id=01388a1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01388a1b",
  null
  
)

export default component.exports